export const initializePiSdk = () => {
  if (window.piAutoInitDone) return;

  const tryInit = () => {
    if (window.Pi && typeof window.Pi.init === "function") {
      console.log("🚀 Initializing Pi SDK...");
      window.Pi.init({
        version: "2.0",
        sandbox: false,
        scopes: ["username", "payments"],
      });
      window.piAutoInitDone = true;
    } else {
      console.warn("⏳ Pi.init not ready, retrying...");
      setTimeout(tryInit, 100);
    }
  };

  tryInit();
};
